<template>
  <!-- Begin Page Content -->
  <div class="container-fluid">
    <!-- Page Heading -->
    <div class="d-sm-flex align-items-center justify-content-between mb-4">
      <h1 class="h3 mb-0 text-gray-800">Logs</h1>
    </div>

    <nav
      class="navbar navbar-expand navbar-light bg-white mb-4 static-top shadow"
    >
      <form
        @submit.prevent="getLogs"
        v-if="userPermissions.some((e) => [P_READ_DEMAND].includes(e))"
        style="width: 100%"
      >
        <div class="row mb-2">
          <!-- <div class=""> -->
          <div class="col-md-4">
            <div class="form-row">
              <label for="debut" class="col-3">Début:</label>
              <VueCtkDateTimePicker
                name="debut"
                class="ml-0 mr-0 pl-0 pr-0 col-9"
                v-model="start_date"
                label="date début"
                color="#0a3764"
                button-color="#0a3764"
                locale="fr"
                input-size="sm"
                format="YYYY-MM-DD HH:mm:ss"
                button-now-translation="Aujourd'hui"
                id="debut"
              />
            </div>
          </div>
          <!-- </div> -->
          <!-- <div class=""> -->
          <div class="col-md-4">
            <div class="form-row">
              <label for="fin" class="col-3">Fin:</label>
              <VueCtkDateTimePicker
                name="fin"
                class="ml-0 mr-0 pl-0 pr-0 col-9"
                v-model="end_date"
                label="date fin"
                color="#0a3764"
                button-color="#0a3764"
                locale="fr"
                input-size="sm"
                format="YYYY-MM-DD HH:mm:ss"
                button-now-translation="Aujourd'hui"
                id="fin"
              />
            </div>
          </div>

          <div class="col-md-4">
            <div class="form-row">
              <label for="statut" class="col-3">Utilisateur:</label>
              <select id="statut" class="form-control col-9" v-model="user">
                <option disabled value="">Sélectionner...</option>
                <option v-for="s in users" :value="s.id" :key="s.id">
                  {{ s.firstname }} {{ s.lastname }}
                </option>
              </select>
            </div>
          </div>
          <!-- </div> -->

          <!-- <div class="col-md-3">
          <div class="form-row">
            <label for="statut" class="col-3">Statut:</label>
            <select id="statut" class="form-control col" v-model="statut">
              <option disabled value="">Sélectionner un statut...</option>
              <option v-for="s in statuts" :value="s.value" :key="s.id">
                {{ s.value }}
              </option>
            </select>
          </div>
        </div> -->

          <!-- <div class="col-md-3">
          <div class="form-row">
            <label for="identifiant" class="col-4">Identifiant:</label>
            <input
              type="text"
              v-model="identifiant"
              name="identifiant"
              id="identifiant"
              class="form-control col"
            />
          </div>
        </div> -->
        </div>

        <div class="row mb-2">
          <div class="col-md-4">
            <div class="form-row">
              <label for="statut" class="col-3">Type:</label>
              <select id="statut" class="form-control col-9" v-model="type">
                <option disabled value="">Sélectionner...</option>
                <option v-for="s in types" :value="s.value" :key="s.id">
                  {{ s.value }}
                </option>
              </select>
            </div>
          </div>

          <div class="col-md-4">
            <div class="form-row">
              <label for="statut" class="col-3">Méthode:</label>
              <select id="statut" class="form-control col-9" v-model="method">
                <option disabled value="">Sélectionner...</option>
                <option v-for="s in methods" :value="s.value" :key="s.id">
                  {{ s.value }}
                </option>
              </select>
            </div>
          </div>

          <div class="col-md-4">
            <div class="form-row">
              <label for="statut" class="col-3">Application:</label>
              <select
                id="statut"
                class="form-control col-9"
                v-model="application"
              >
                <option disabled value="">Sélectionner...</option>
                <option v-for="s in applications" :value="s.value" :key="s.id">
                  {{ s.value }}
                </option>
              </select>
            </div>
          </div>
        </div>

        <hr />

        <div class="row">
          <label class="col-md-1"></label>
          <div class="col-md-11">
            <button
              type="submit"
              class="btn btn-primary mr-2"
              title="Lancer la recherche"
            >
              Rechercher
            </button>
            <button
              class="btn btn-outline-primary"
              title="Effacer le filtre"
              type="button"
              @click="resetFilter"
            >
              Effacer le filtre
            </button>
          </div>
        </div>
      </form>
    </nav>

    <!-- Affichage d'erreur -->
    <div class="form-group">
      <div
        class="alert text-left formatted-text"
        :class="{
          'alert-danger': error,
        }"
        role="alert"
        v-show="error"
      >
        {{ this.error }}
      </div>
    </div>

    <div
      class="table-responsive"
      v-if="userPermissions.some((e) => [P_READ_DEMAND].includes(e))"
    >
      <nav
        v-if="!(Object.keys(logs).length === 0 && logs.constructor === Object)"
        aria-label="Log list search pagination top"
      >
        <ul class="pagination">
          <li
            v-for="(v, index) in logs.meta.links"
            :key="index"
            class="page-item"
            :class="{ active: v.active, disabled: v.url === null }"
            :aria-current="{ page: v.active }"
            @click="getLogs(getNextPageIndex(v.url))"
          >
            <router-link class="page-link" to="">
              {{
                index === 0
                  ? "&laquo; Précédent"
                  : index === logs.meta.links.length - 1
                  ? "Suivant &raquo;"
                  : v.label
              }}
              <span v-if="v.active" class="sr-only">(current)</span>
            </router-link>
          </li>
        </ul>
      </nav>

      <table
        v-if="!(Object.keys(logs).length === 0 && logs.constructor === Object)"
        id="dataTable"
        class="table table-bordered table-striped table-hover"
      >
        <thead>
          <tr>
            <th>Description</th>
            <th>Type</th>
            <th>Utilisateur</th>
            <th>Route</th>
            <th>Statut</th>
            <th>Méthode</th>
            <th>Application</th>
            <th>Créé le</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          <LogItem v-for="log in logs.data" :log="log" :key="log.id" />
        </tbody>
      </table>

      <div v-else>
        <p style="text-align: center">
          <br />
          Aucunes données
        </p>
      </div>

      <nav
        v-if="!(Object.keys(logs).length === 0 && logs.constructor === Object)"
        aria-label="Log list search pagination top"
      >
        <ul class="pagination">
          <li
            v-for="(v, index) in logs.meta.links"
            :key="index + 'a'"
            class="page-item"
            :class="{ active: v.active, disabled: v.url === null }"
            :aria-current="{ page: v.active }"
            @click="getLogs(getNextPageIndex(v.url))"
          >
            <router-link class="page-link" to="">
              {{
                index === 0
                  ? "&laquo; Précédent"
                  : index === logs.meta.links.length - 1
                  ? "Suivant &raquo;"
                  : v.label
              }}
              <span v-if="v.active" class="sr-only">(current)</span>
            </router-link>
          </li>
        </ul>
      </nav>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

import { FETCH_LOGS, FETCH_USERS } from "@/store/actions.type";
import { SET_LOADING } from "@/store/mutations.type";
import { P_READ_DEMAND } from "@/helpers/permissions";
import LogItem from "./LogItem";

export default {
  components: {
    LogItem,
  },
  data() {
    return {
      start_date: "",
      end_date: "",
      statut: "",
      identifiant: "",
      statuts: [
        { id: 1, value: "GENERATED" },
        { id: 2, value: "PROCESSING" },
        { id: 3, value: "VALIDATION" },
      ],
      types: [
        { id: 1, value: "automatic" },
        { id: 2, value: "manual" },
      ],
      type: "",
      methods: [
        { id: 1, value: "GET" },
        { id: 2, value: "POST" },
        { id: 3, value: "PUT" },
        { id: 4, value: "DELETE" },
        { id: 5, value: "CRON" },
      ],
      method: "",
      applications: [
        { id: 1, value: "backend" },
        { id: 2, value: "front-office" },
      ],
      application: "",
      user: "",
      error: "",
      P_READ_DEMAND,
    };
  },
  async mounted() {
    await this.getLogs();
    await this.getusers();
  },
  computed: {
    ...mapGetters(["logs", "userPermissions", "users"]),
  },
  methods: {
    getLogs(page = 1) {
      if (page === null) {
        return;
      }
      if (typeof page != "number") {
        page = 1;
      }

      this.$store.commit(SET_LOADING, true);

      let params = {};
      params.page = page;
      if (this.start_date) params.startdate = this.start_date;
      if (this.end_date) params.enddate = this.end_date;
      if (this.user) params.user = this.user;
      if (this.type) params.type = this.type;
      if (this.method) params.method = this.method;
      if (this.application) params.application = this.application;

      this.$store
        .dispatch(FETCH_LOGS, params)
        .catch((error) => {
          this.error = `${error}`;
          if (error.errors) {
            this.error += ` \n ${JSON.stringify(error.errors)} `;
          }
        })
        .finally(() => {
          this.$store.commit(SET_LOADING, false);
        });
    },
    getusers() {
      this.$store.commit(SET_LOADING, true);
      this.$store
        .dispatch(FETCH_USERS)
        .catch(() => {})
        .finally(() => {
          this.$store.commit(SET_LOADING, false);
        });
    },
    getNextPageIndex(url) {
      if (url === null) {
        return null;
      }

      return parseInt(url.split("?")[1].split("=")[1]);
    },
    resetFilter() {
      this.start_date = "";
      this.end_date = "";
      this.type = "";
      this.user = "";
      this.method = "";
      this.application = "";
    },
  },
};
</script>

<style lang="scss" scoped>
.form-row {
  display: flex;
  align-items: center;
}
label {
  margin-bottom: unset !important;
}
</style>